"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _classCallCheck = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderError = exports.ProviderErrorCode = void 0;
var ProviderErrorCode;

(function (ProviderErrorCode) {
  ProviderErrorCode[ProviderErrorCode["USER_DENIED_REQUEST_ACCOUNTS"] = 4001] = "USER_DENIED_REQUEST_ACCOUNTS";
  ProviderErrorCode[ProviderErrorCode["USER_DENIED_CREATE_ACCOUNT"] = 4010] = "USER_DENIED_CREATE_ACCOUNT";
  ProviderErrorCode[ProviderErrorCode["UNAUTHORIZED"] = 4100] = "UNAUTHORIZED";
  ProviderErrorCode[ProviderErrorCode["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
  ProviderErrorCode[ProviderErrorCode["USER_DENIED_REQUEST_SIGNATURE"] = -32603] = "USER_DENIED_REQUEST_SIGNATURE";
})(ProviderErrorCode = exports.ProviderErrorCode || (exports.ProviderErrorCode = {}));

var ProviderError =
/*#__PURE__*/
function (_Error) {
  _inherits(ProviderError, _Error);

  function ProviderError(message, code, data) {
    var _this;

    _classCallCheck(this, ProviderError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProviderError).call(this, message || "Provider Error"));
    _this.code = code;
    _this.data = data;
    _this.name = "ProviderError";
    Object.setPrototypeOf(_assertThisInitialized(_this), ProviderError.prototype);
    return _this;
  }

  return ProviderError;
}(_wrapNativeSuper(Error));

exports.ProviderError = ProviderError;